var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFieldArray } from 'react-hook-form';
import { OGPanel } from '@opengear/panel';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { OGButton } from '@opengear/buttons';
import AddIcon from '@mui/icons-material/AddCircleOutlineSharp';
import DeleteIcon from '@mui/icons-material/Delete';
import { DescriptionField, NameField } from './user-group-form-controls';
import { UserForm, UserTable, getDefaultUserFormState } from './users';
import { GroupsTable } from './groups';
import { CancelButton, FormActions, FormContainer, SubmitButton } from '@/components/layout/forms';
import { USER_GROUP_TEMPLATES_ROUTE } from '@/constants/routes';
import { transformFormStateToRequest } from './transformers';
import { useCreateTemplate, useUpdateTemplate } from '@/api/template/templates';
import { UserGroupModal } from './user-group-modal';
import { useOpen } from '@/hooks/open';
import { GroupForm } from './groups';
import { getDefaultGroupFormState } from './groups/group-form';
import { DeleteTemplateModal } from '../delete-template-modal';
import { useFormSync } from '@/hooks/use-form-sync';
var USER_GROUP_MODAL_TITLE_ID = 'user-group-modal-title-id';
export function UserGroupForm(_a) {
    var _this = this;
    var permissions = _a.permissions, data = _a.data, templateId = _a.templateId;
    var t = useTranslation().t;
    var createTemplate = useCreateTemplate();
    var updateTemplate = useUpdateTemplate();
    // Primary form
    var methods = useForm({ mode: 'onTouched', defaultValues: data });
    var navigate = useNavigate();
    var onCancel = useCallback(function () {
        navigate(USER_GROUP_TEMPLATES_ROUTE);
    }, [navigate]);
    var onSubmit = useCallback(function (formData) { return __awaiter(_this, void 0, void 0, function () {
        var request, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    request = transformFormStateToRequest(formData);
                    if (!templateId) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateTemplate({ template: request, id: templateId })];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, createTemplate({ template: request })];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    response = _a;
                    if (response) {
                        navigate(USER_GROUP_TEMPLATES_ROUTE);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [createTemplate, navigate, templateId, updateTemplate]);
    useFormSync(methods.formState.defaultValues, data, methods.reset, t('pages.config_templates.tabs.users_groups.reset_warning.header'));
    // Group forms
    var _b = __read(useState(null), 2), editGroup = _b[0], setEditGroup = _b[1];
    var createGroupOpen = useOpen();
    var updateGroupOpen = useOpen();
    var _c = useFieldArray({
        keyName: 'fieldId',
        name: 'groups',
        control: methods.control,
        rules: { required: true },
    }), groups = _c.fields, appendGroup = _c.append, updateGroup = _c.update, removeGroup = _c.remove;
    var updateGroupIndex = useMemo(function () {
        if (!editGroup)
            return -1;
        return groups.findIndex(function (_a) {
            var id = _a.id;
            return id === editGroup.id;
        });
    }, [groups, editGroup]);
    var onCreateGroup = useCallback(function (formData) {
        appendGroup(formData);
        createGroupOpen.handleClose();
    }, [appendGroup, createGroupOpen]);
    var onUpdateGroup = useCallback(function (formData) {
        updateGroup(updateGroupIndex, formData);
        updateGroupOpen.handleClose();
    }, [updateGroup, updateGroupIndex, updateGroupOpen]);
    var onDeleteGroup = useCallback(function () {
        removeGroup(updateGroupIndex);
        updateGroupOpen.handleClose();
    }, [removeGroup, updateGroupIndex, updateGroupOpen]);
    var handleGroupClick = useCallback(function (group) {
        setEditGroup(group);
        updateGroupOpen.handleOpen();
    }, [updateGroupOpen]);
    // User forms
    var _d = __read(useState(null), 2), editUser = _d[0], setEditUser = _d[1];
    var createUserOpen = useOpen();
    var updateUserOpen = useOpen();
    var _e = useFieldArray({
        keyName: 'fieldId',
        name: 'users',
        control: methods.control,
    }), users = _e.fields, appendUser = _e.append, updateUser = _e.update, removeUser = _e.remove;
    var updateUserIndex = useMemo(function () {
        if (!editUser)
            return -1;
        return users.findIndex(function (_a) {
            var id = _a.id;
            return id === editUser.id;
        });
    }, [users, editUser]);
    var onCreateUser = useCallback(function (formData) {
        appendUser(formData);
        createUserOpen.handleClose();
    }, [appendUser, createUserOpen]);
    var onUpdateUser = useCallback(function (formData) {
        updateUser(updateUserIndex, formData);
        updateUserOpen.handleClose();
    }, [updateUser, updateUserIndex, updateUserOpen]);
    var onDeleteUser = useCallback(function () {
        removeUser(updateUserIndex);
        updateUserOpen.handleClose();
    }, [removeUser, updateUserIndex, updateUserOpen]);
    var handleUserClick = useCallback(function (user) {
        setEditUser(user);
        updateUserOpen.handleOpen();
    }, [updateUserOpen]);
    var usernames = users.map(function (user) { return user.username; });
    return (_jsxs(_Fragment, { children: [_jsx(OGPanel, { children: _jsxs(FormContainer, __assign({ methods: methods, onSubmit: onSubmit, permissions: permissions, mode: templateId ? 'update' : 'create' }, { children: [_jsxs(Box, __assign({ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 1, alignItems: "center" }, { children: [_jsx(Typography, __assign({ component: "h3", variant: "h3", sx: { textTransform: 'uppercase' }, marginBottom: 2 }, { children: t('pages.config_templates.tabs.users_groups.sections.template_details.label') })), _jsx(Box, { flexGrow: 1 }), templateId && _jsx(DeleteTemplateModal, { editable: permissions.hasEditPermission, templateId: templateId, redirectUrl: USER_GROUP_TEMPLATES_ROUTE })] })), _jsx(NameField, {}), _jsx(DescriptionField, {}), _jsx(Typography, __assign({ component: "h3", variant: "h3", sx: { textTransform: 'uppercase', marginBottom: 2 } }, { children: t('pages.config_templates.tabs.users_groups.sections.group_list.label') })), _jsx(GroupsTable, { onGroupClick: handleGroupClick }), _jsx(OGButton, __assign({ startIcon: _jsx(AddIcon, {}), variant: "secondary", onClick: createGroupOpen.handleOpen, sx: { alignSelf: 'start', marginTop: 2 }, disabled: !permissions.hasEditPermission }, { children: t('pages.config_templates.tabs.users_groups.sections.group_list.actions.create') })), _jsx(Typography, __assign({ component: "h3", variant: "h3", sx: { textTransform: 'uppercase', marginBottom: 2, marginTop: 2 } }, { children: t('pages.config_templates.tabs.users_groups.sections.user_list.label') })), _jsx(UserTable, { onUserClick: handleUserClick }), _jsx(OGButton, __assign({ startIcon: _jsx(AddIcon, {}), variant: "secondary", onClick: createUserOpen.handleOpen, sx: { alignSelf: 'start', marginTop: 2 }, disabled: !permissions.hasEditPermission }, { children: t('pages.config_templates.tabs.users_groups.sections.user_list.actions.create') })), _jsxs(FormActions, { children: [_jsx(CancelButton, { onCancel: onCancel }), _jsx(SubmitButton, { children: t('pages.config_templates.tabs.users_groups.actions.create') })] })] })) }), _jsx(Typography, __assign({ component: "div", marginTop: 2 }, { children: t('pages.config_templates.tabs.users_groups.warning') })), _jsx(UserGroupModal, __assign({ useOpen: createGroupOpen, title: t('pages.config_templates.tabs.users_groups.sections.group_list.actions.create'), titleId: USER_GROUP_MODAL_TITLE_ID }, { children: _jsx(GroupForm, __assign({ ariaLabelledBy: USER_GROUP_MODAL_TITLE_ID, onSubmit: onCreateGroup, permissions: permissions, mode: "create", defaultValues: getDefaultGroupFormState() }, { children: _jsx(Box, __assign({ sx: { px: 2, pb: 2 } }, { children: _jsxs(FormActions, { children: [_jsx(CancelButton, { onCancel: createGroupOpen.handleClose }), _jsx(SubmitButton, { children: t('pages.config_templates.tabs.users_groups.sections.group_list.actions.create') })] }) })) })) })), _jsx(UserGroupModal, __assign({ useOpen: updateGroupOpen, title: t('pages.config_templates.tabs.users_groups.sections.group_list.actions.update'), titleId: USER_GROUP_MODAL_TITLE_ID }, { children: editGroup && (_jsx(GroupForm, __assign({ onSubmit: onUpdateGroup, permissions: permissions, mode: "update", defaultValues: editGroup, ariaLabelledBy: USER_GROUP_MODAL_TITLE_ID }, { children: _jsxs(Box, __assign({ sx: { px: 2, pb: 2, mt: 2, display: 'flex', justifyContent: 'space-between' } }, { children: [_jsx(OGButton, __assign({ disabled: !permissions.hasEditPermission, onClick: onDeleteGroup, startIcon: _jsx(DeleteIcon, {}), variant: "secondary" }, { children: t('global.buttons.delete') })), _jsxs(Box, __assign({ sx: { display: 'flex', gap: 1, justifyContent: 'end' } }, { children: [_jsx(CancelButton, { onCancel: updateGroupOpen.handleClose }), _jsx(SubmitButton, { children: t('pages.config_templates.tabs.users_groups.sections.group_list.actions.update') })] }))] })) }))) })), _jsx(UserGroupModal, __assign({ useOpen: createUserOpen, title: t('pages.config_templates.tabs.users_groups.sections.user_list.actions.create'), titleId: USER_GROUP_MODAL_TITLE_ID }, { children: _jsx(UserForm, __assign({ onSubmit: onCreateUser, permissions: permissions, mode: "create", groups: groups, usernames: usernames, defaultValues: getDefaultUserFormState(), ariaLabelledBy: USER_GROUP_MODAL_TITLE_ID }, { children: _jsx(Box, __assign({ sx: { px: 2, pb: 2 } }, { children: _jsxs(FormActions, { children: [_jsx(CancelButton, { onCancel: createUserOpen.handleClose }), _jsx(SubmitButton, { children: t('pages.config_templates.tabs.users_groups.sections.user_list.actions.create') })] }) })) })) })), _jsx(UserGroupModal, __assign({ useOpen: updateUserOpen, title: t('pages.config_templates.tabs.users_groups.sections.user_list.actions.update'), titleId: USER_GROUP_MODAL_TITLE_ID }, { children: editUser && (_jsx(UserForm, __assign({ onSubmit: onUpdateUser, permissions: permissions, mode: "update", groups: groups, usernames: usernames, defaultValues: editUser, ariaLabelledBy: USER_GROUP_MODAL_TITLE_ID }, { children: _jsxs(Box, __assign({ sx: { px: 2, pb: 2, mt: 2, display: 'flex', justifyContent: 'space-between' } }, { children: [_jsx(OGButton, __assign({ disabled: !permissions.hasEditPermission, onClick: onDeleteUser, startIcon: _jsx(DeleteIcon, {}), variant: "secondary" }, { children: t('global.buttons.delete') })), _jsxs(Box, __assign({ sx: { display: 'flex', gap: 1, justifyContent: 'end' } }, { children: [_jsx(CancelButton, { onCancel: updateUserOpen.handleClose }), _jsx(SubmitButton, { children: t('pages.config_templates.tabs.users_groups.sections.user_list.actions.update') })] }))] })) }))) }))] }));
}
